import { z } from 'zod';

/** Email validation — mirrors @Email + @NotBlank + @NoXss + @Size(max=255) */
export const passwordResetRequestSchema = z.object({
  email: z
    .string()
    .min(1, 'pwReset.request.email.required')
    .max(255, 'pwReset.request.email.tooLong')
    .email('pwReset.request.email.invalid'),
});

export type PasswordResetRequestFormValues = z.infer<typeof passwordResetRequestSchema>;

/** Password policy — mirrors @Password(min=10, max=64): 대소문자/숫자/특수 각 1개 이상 */
const passwordPolicy = z
  .string()
  .min(10, 'pwReset.confirm.password.tooShort')
  .max(64, 'pwReset.confirm.password.tooLong')
  .regex(/[A-Z]/, 'pwReset.confirm.password.requireUpper')
  .regex(/[a-z]/, 'pwReset.confirm.password.requireLower')
  .regex(/[0-9]/, 'pwReset.confirm.password.requireDigit')
  .regex(/[^A-Za-z0-9]/, 'pwReset.confirm.password.requireSpecial');

export const passwordResetConfirmSchema = z
  .object({
    newPassword: passwordPolicy,
    confirmPassword: z.string().min(1, 'pwReset.confirm.confirmPassword.required'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'pwReset.confirm.confirmPassword.mismatch',
    path: ['confirmPassword'],
  });

export type PasswordResetConfirmFormValues = z.infer<typeof passwordResetConfirmSchema>;
